import React, { Component, createRef } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'

class Message extends Component {
  constructor(props) {
    super(props);
    this.banner = createRef();
  }

  componentDidMount() {
    this.banner.current?.focus();
  }

  setFocusBack = () => {
    const messageData = this.props.message.data;
    messageData.dismissed = true
    this.props.message.data = messageData

    var cannotFindFocus = false;

    if (messageData?.idBack != null) {
      if (document.getElementById(messageData.idBack) === null) {
        cannotFindFocus = true;
      } else {
        document.getElementById(messageData.idBack).focus();
      }
    } else if (messageData?.refBack != null) {
      if (messageData.refBack.current === null) {
        cannotFindFocus = true;
      } else {
        messageData.refBack.current.focus();
      }
    }

    if (cannotFindFocus) {
      this.props.defaultFocus.current?.focus();
    }
  }

  render() {
    const { message } = this.props;

    if (message === null) {
      return null;
    }

    return (
          <MessageBanner
            ref={this.banner}
            isDismissible={true}
            dismissButtonAltText={"Dismiss message " + message.id + " " + message.text}
            type={mapFlashMessageTypeToStencilMessageBannerType(message.type)}
            onDismissed={() => this.setFocusBack()}
          >
            {message.text}
          </MessageBanner>
    )
  }
}

const mapFlashMessageTypeToStencilMessageBannerType = (messageType) => {
  switch (messageType) {
    case "SUCCESS":
      return MessageBannerType.Success;
    case "ERROR":
      return MessageBannerType.Error;
    default:
      return MessageBannerType.Informational;
  }
}

export default withRouter(connect(null)(withTranslation('translationsV2')(Message)))
